import React from 'react';
import { motion } from 'framer-motion';

export default function Card({
  children,
  className = '',
  hover = false,
  as: Component = 'div',
  ...props
}) {
  const content = (
    <Component className={`ui-card ${hover ? 'ui-card-hover' : ''} ${className}`} {...props}>
      {children}
    </Component>
  );

  if (!hover) return content;

  return (
    <motion.div whileHover={{ y: -3 }} transition={{ duration: 0.18 }}>
      {content}
    </motion.div>
  );
}

export function CardHeader({ title, subtitle, action, className = '' }) {
  return (
    <div className={`ui-card-header ${className}`}>
      <div>
        <h2>{title}</h2>
        {subtitle ? <p>{subtitle}</p> : null}
      </div>
      {action ? <div className="ui-card-action">{action}</div> : null}
    </div>
  );
}
